import React from "react";
import {
  Modal,
  Input,
  Form,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Table,
  Empty,
  Checkbox,
  Select
} from "antd";
import moment from "moment";
import "./styles.css";
import { FORMAT_3DECIMALS } from "../../../common/types/regularExpresionType";

const InputGroup = Input.Group;
const { TabPane } = Tabs;
const { Option } = Select;
class FormModalVer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    getFieldDecorator("id", { initialValue: this.props.formValues.id });
    getFieldDecorator("arrDetalle", { initialValue: [] });

    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });
    getFieldDecorator("sumaIgv", {
      initialValue: this.props.formValues.sumaIgv,
    });
    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });

    return (
      <Modal
        title={<div>Ver Guía de Remisión</div>}
        visible={this.props.visible}
        style={{ top: 30 }}
        cancelText={"Cancelar"}
        okText={"Ok"}
        onCancel={this.handleCancel}
        onOk={this.handleCancel}
        width="1050px"
      >
        <Form>
          {getFieldDecorator("id", { initialValue: this.props.formValues.id })(
            <input type="hidden" />
          )}

          {getFieldDecorator("idComprobante", {
            initialValue: this.props.formValues.idComprobante,
          })(<input type="hidden" />)}

          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "40%" }}>
                    {getFieldDecorator("serie", {
                      initialValue: this.props.formValues.serie,
                    })(
                      <Input
                        placeholder="Serie"
                        autoComplete="off"
                        className="first-input"
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "60%" }}>
                    {getFieldDecorator("documento", {
                      initialValue: this.props.formValues.documento,
                    })(
                      <Input
                        placeholder="Documento"
                        autoComplete="off"
                        className="second-input"
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Fecha Emisión">
                <InputGroup compact>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("tipoCambio", {
                      initialValue: parseFloat(
                        this.props.formValues.tipoCambio
                      ).toFixed(3),
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_3DECIMALS),
                          message: "Formato decimal incorrecto (0.000)",
                        },
                      ],
                    })(
                      <Input
                        className="text-right second-input"
                        placeholder="Ingresar Tipo de Cambio"
                        autoComplete="off"
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Fecha Traslado">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaTrasladoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaTrasladoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha de traslado"
                        disabled={true}
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Motivo">
                {getFieldDecorator("motivoTraslado", {
                  initialValue: this.props.formValues.motivoTraslado,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-9 form-group">
              <Form.Item label="Cliente">
                <InputGroup compact>
                  <Form.Item style={{ width: "20%" }}>
                    {getFieldDecorator("documentoCliente", {
                      initialValue: this.props.formValues.documentoCliente,
                    })(<Input readOnly={true} />)}
                  </Form.Item>
                  <Form.Item style={{ width: "80%" }}>
                    {getFieldDecorator("razonSocialEntidad", {
                      initialValue: this.props.formValues.razonSocialEntidad,
                    })(<Input readOnly={true} />)}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Traslado">
                {getFieldDecorator("traslado", {
                  initialValue: this.props.formValues.traslado,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Dirección Partida">
                {getFieldDecorator("direccionPartida", {
                  initialValue: this.props.formValues.direccionPartida,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Departamento">
                {getFieldDecorator("departamentoPartida", {
                  initialValue: this.props.formValues.departamentoPartida,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Provincia">
                {getFieldDecorator("provinciaPartida", {
                  initialValue: this.props.formValues.provinciaPartida,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Distrito">
                {getFieldDecorator("distritoPartida", {
                  initialValue: this.props.formValues.distritoPartida,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Dirección Llegada">
                {getFieldDecorator("direccionLlegada", {
                  initialValue: this.props.formValues.direccionLlegada,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Departamento">
                {getFieldDecorator("departamentoLlegada", {
                  initialValue: this.props.formValues.departamentoLlegada,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Provincia">
                {getFieldDecorator("provinciaLlegada", {
                  initialValue: this.props.formValues.provinciaLlegada,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Distrito">
                {getFieldDecorator("distritoLlegada", {
                  initialValue: this.props.formValues.distritoLlegada,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
          </div>

          <div className="row">

            <div className="col-md-4 form-group">
              <Form.Item label="Chofer">
                {getFieldDecorator("chofer", {
                  initialValue: this.props.formValues.chofer,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>

            <div className="col-md-2 form-group">
              <Form.Item label="Licencia">
                {getFieldDecorator("licencia", {
                  initialValue: this.props.formValues.licencia,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Vehiculo">
                {getFieldDecorator("vehiculo", {
                  initialValue: this.props.formValues.vehiculo,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>


            <div className={"col-md-2 form-group"}>
              <Form.Item label="Tuc">
                {getFieldDecorator("tuc", {
                  initialValue: this.props.formValues.tuc,
                })(
                  <Input
                    placeholder="Ingresar Tuc"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>

          </div>

          <div className="row">


            <div
              className="col-md-12 form-group"
            // style={{
            //   display: !this.props.form.getFieldValue("flagTransportePrivado")
            //     ? ""
            //     : "none",
            // }}
            >
              <Form.Item label="E.Transporte">
                {getFieldDecorator("transporte", {
                  initialValue: this.props.formValues.transporte,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
          </div>

          <div className="row"
            style={{
              display: this.props.formValues.codigoDam != null
                ? ""
                : "none",
            }}
          >
            <div className="col-md-6 form-group">
              <Form.Item label="Documento Relacionado">
                {getFieldDecorator('codigoDam', {
                  initialValue: this.props.formValues.codigoDam ?
                    { key: this.props.formValues.codigoDam } : "",
                })(
                  <Select labelInValue
                    placeholder={"Seleccione Documento"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.tiposComprobante.map(item => (
                      item.codigoSunat == "50" || item.codigoSunat == "52" ?
                        <Option key={item.codigoSunat} value={item.codigoSunat}>{item.codigoSunat + "-" + item.nombre}</Option>
                        : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Serie DAM / DS">
                {getFieldDecorator("serieDam", {
                  initialValue: this.props.formValues.serieDam,
                })(
                  <Input
                    placeholder="xxxx"
                    autoComplete="off"
                    readOnly={true}
                  />
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Númeración de la DAM / DS">
                {getFieldDecorator("dam", {
                  initialValue: this.props.formValues.dam,
                })(
                  <Input
                    placeholder="xxx-xxxx-xx-xxxxxx"
                    autoComplete="off"
                    className="second-input"
                    readOnly={true}
                  />
                )}
              </Form.Item>
            </div>
          </div>


          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Observación">
                {getFieldDecorator("observacion", {
                  initialValue: this.props.formValues.observacion,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Descripción">
                {getFieldDecorator("descripcion", {
                  initialValue: this.props.formValues.descripcion,
                  rules: [{
                    required: true,
                    message: 'Campo obligatorio.',
                  }]
                })(
                  <Input
                    placeholder="Ingresar Descripción"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Proyecto">
                {getFieldDecorator('idProyecto', {
                  initialValue: this.props.formValues.idProyecto ?
                    { key: this.props.formValues.idProyecto } : 0
                })(
                  <Select showSearch labelInValue
                    placeholder={"Seleccione Proyecto"}
                    optionFilterProp="children"
                  >
                    <Option key={0} value={0}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option>
                    {this.props.formValues.proyectos.map(item => (
                      item.estado ?
                        <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Cantidad Bultos">
                {getFieldDecorator("bultos", {
                  initialValue: this.props.formValues.bultos,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Peso Bruto Total Carga (KG)">
                {getFieldDecorator("totalPesoCarga", {
                  initialValue: this.props.formValues.totalPesoCarga,
                })(<Input readOnly={true} />)}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs
                activeKey={this.props.formValues.activeKey}
                onChange={this.props.onChangeTab}
              // tabBarExtraContent={
              //   <Button
              //     icon="plus"
              //     type="primary"
              //     onClick={() =>
              //       this.props.onAgregarDetalle(
              //         this.props.form.setFieldsValue,
              //         this.props.form.getFieldValue
              //       )
              //     }
              //   >
              //     Agregar
              //   </Button>
              // }
              >
                <TabPane tab="Detalle de Productos y Servicios" key="1">
                  <Table
                    className={"table-producto"}
                    scroll={{ x: true }}
                    size="small"
                    style={{ overflowX: "auto" }}
                    pagination={false}
                    dataSource={this.props.formValues.listaComprobanteDetalle}
                    rowKey={(record) => record.idProducto}
                    locale={{
                      emptyText: (
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description="No se han agregado productos"
                        />
                      ),
                    }}
                    columns={[
                      {
                        title: "Código",
                        dataIndex: "codigo",
                        key: "codigo",
                        align: "center",
                        width: 80,
                        ellipsis: true,
                      },
                      {
                        title: "Nombre",
                        dataIndex: "nombre",
                        key: "nombre",
                        width: 250,
                        ellipsis: true,
                        render: (value, row) => {
                          return (
                            <Input
                              placeholder="Nombre"
                              autoComplete="off"
                              className="text-left"
                              readOnly={true}
                              value={value}
                            />
                          )
                        }
                      },
                      {
                        title: "Unidad Medida",
                        dataIndex: "nombreUnidadMedida",
                        key: "nombreUnidadMedida",
                        width: 120,
                        ellipsis: true,
                      },
                      //   {
                      //     title: "Lote",
                      //     dataIndex: "lote",
                      //     key: "lote",
                      //     width: 120,
                      //     ellipsis: true,
                      //   },
                      {
                        title: "Peso Unitario",
                        dataIndex: "pesoUnitario",
                        key: "pesoUnitario",
                        align: "center",
                        width: 90,
                        render: (value, row) => {
                          return (
                            <span> {value.toFixed(2)} </span>
                          )
                        }
                      },
                      {
                        title: "Cantidad",
                        dataIndex: "cantidad",
                        key: "cantidad",
                        align: "center",
                        width: 90,
                        render: (value, row) => {
                          return (
                            <span> {value.toFixed(2)} </span>
                          )
                        }
                      },
                      {
                        title: "Peso Total",
                        dataIndex: "totalPeso",
                        key: "totalPeso",
                        align: "center",
                        width: 90,
                        render: (value, row) => {
                          return (
                            <span> {value.toFixed(2)} </span>
                          )
                        }
                      },
                    ]}
                  />
                </TabPane>
                <TabPane tab="Detalle de Referencias" key="2">
                  <Table
                    className={"table-referencia"}
                    scroll={{ x: true }}
                    size="small"
                    style={{ overflowX: "auto" }}
                    pagination={false}
                    dataSource={
                      this.props.formValues.listaComprobanteReferencia
                    }
                    rowKey={(record) => record.identifier}
                    // locale={{
                    //   emptyText: (
                    //     <Empty
                    //       image={Empty.PRESENTED_IMAGE_SIMPLE}
                    //       description='Pulse el botón "+ Agregar".'
                    //     />
                    //   ),
                    // }}
                    columns={[
                      {
                        title: "Tipo Comprobante",
                        dataIndex: "nombreTipoComprobante",
                        key: "nombreTipoComprobante",
                        align: "center",
                        width: 350,
                        ellipsis: true,
                      },
                      {
                        title: "Serie",
                        dataIndex: "serie",
                        key: "serie",
                        width: 100,
                        ellipsis: true,
                      },
                      {
                        title: "Documento",
                        dataIndex: "documento",
                        key: "documento",
                        width: 120,
                        ellipsis: true,
                      },
                    ]}
                  />
                </TabPane>

                <TabPane tab="Contenedores" key="3">
                  <Table
                    className={"table-referencia"}
                    scroll={{ x: true }}
                    size="small"
                    style={{ overflowX: "auto" }}
                    pagination={false}
                    dataSource={
                      this.props.formValues.contenedores
                    }
                    rowKey={(record) => record.identifier}
                    columns={[

                      {
                        title: 'Número de Contenedor',
                        dataIndex: "numero",
                        key: "numero",
                        width: 100,
                        align: "center",
                        ellipsis: true,
                      },
                      {
                        title: 'Número de Precinto ',
                        dataIndex: "precinto",
                        key: "precinto",
                        width: 120,
                        align: "center",
                        ellipsis: true,
                      },
                    ]}
                  />
                </TabPane>
              </Tabs>
            </div>
          </div>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(FormModalVer);
